import $http from '@/libs/axios'

export interface SendPushPayload {
  has_active_pages?: boolean;
  has_expired_pages?: boolean;
  has_trial_pages?: boolean;
  date_from?: string;
  date_to?: string;
  subject: string;
  body: string;
  image?: string;
}

export interface SendPushResponse {
  error: number;
  message: string;
  users_matched: number;
  tokens_sent: number;
  success_count: number;
  failure_count: number;
}

export default class AdminPushNotificationsApi {
  static async send(payload: SendPushPayload): Promise<SendPushResponse> {
    const { data } = await $http.post<SendPushResponse>('admin/push-notifications/send', payload)
    return data
  }
}
